module.exports = __webpack_public_path__ + "DINNextLTPro-HeavyItalic.woff2?2dbe69af28942c7ac69c908e2aea4d80";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-HeavyItalic.woff2
// module id = 1412
// module chunks = 0